export default __webpack_public_path__ + "static/media/enviro-trash.b0011a04.png";